import { memo } from "react";
import Slider from "react-slick";
import { MOST_VIEWED_SETTINGS } from "../../constants/sliderSettings";
import type { MostViewedVideo } from "../../types/home";

interface MostViewedVideosProps {
  videos: MostViewedVideo[];
  onSelect: (video: MostViewedVideo) => void;
}

const MostViewedVideos = ({ videos, onSelect }: MostViewedVideosProps) => (
  <div className="w-100 my-5 px-3 pb-5 pt-5">
    <div className="container-xxl">
      <div className="row mx-0">
        <div className="col-12 col-md-8 mx-md-auto m-0 text-start text-md-center">
          <h5 className="fw-bold">Most Viewed Videos</h5>
          <p className="text-break fw-light">
            Enjoy unlimited access to this top quality quick learning service;
            learn a new language, discover new hobbies, improve your professional
            profile, achieve personal development goals, and much more with
            courses designed by subject matter experts.
          </p>
        </div>

        {videos.length > 0 && (
          <div className="col-12 col-md-8 mx-md-auto mt-5">
            <Slider {...MOST_VIEWED_SETTINGS} className="mostViewed">
              {videos.map((video) => (
                <a
                  key={video.id}
                  className="link-dark"
                  onClick={() => onSelect(video)}
                >
                  <div>
                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="w-100"
                    />
                    <div className="ms-2">
                      <h6 className="mt-3">{video.title}</h6>
                      <small className="fw-light">{video.description}</small>
                    </div>
                  </div>
                </a>
              ))}
            </Slider>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default memo(MostViewedVideos);
